module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre3"
  }, [_vm._v("Vorspiel")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Auf dem Schloß »Unserer Frauen Berg« bei Würzburg.\nDie große Hofstube. Links eine Art Thron mit Baldachin. Eine Anzahl\nRitter, geharnischte und ungeharnischte, stehen abwartend oder\nbewegen sich, halblaut miteinander redend. An einer Fensternische,\nrechts, steht der Schreiber Gilgenessig, ein kleines, vertrocknetes\nMännchen, und liest einigen Rittern aus einer Flugschrift laut vor.\nUnter den Zuhörenden: Hans von Lichtenstein, ein etwa\nvierzigjähriger Domherr, Heinz von Stein, Ritter, Wolf von\nHanstein, Ritter, Hans von Grumbach, Ritter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Zum ersten ist unsre demütige\nBitt . . .«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("knirschend.")]), _vm._v(" Ei, du Speikatz! Fast demütig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Zum ersten ist unsre demütige Bitt, daß eine\nganze Gemeine Macht soll haben, ihren Pfarrherrn selbst erwählen\nund kiesen. Der soll uns das Evangelium predigen, lauter, klar, ohn\nalle menschliche Zusätz.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schnaufend.")]), _vm._v(" Ein fast demütig und untertäniges\nSupplizieren, mit Flegeln und Hauen, Spießen und Hakenbüchsen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". Nach dem\nKirchendieb- und Ketzerpaternoster!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Dünket euch das\nein so unbillig Erfordern, ihr Herrn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". Lies, Schreiber,\nlies!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Es riecht\nhie ein wenig nach Lutherischer Grütz, Karlstattscher Suppen und\nHussitischer Pestilenz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Dünket euch das\nso unbillig, ihr Herrn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Grumbach")]), _vm._v(". Ei, leid dich,\nWolf! Das Männlein zerplatzet dir sonst vor Wut!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("laut.")]), _vm._v(" Wie steht's in der Schrift geschrieben? »Ich\nwill meine Herd erlösen von ihrem Mund.« Ihr habt die Milch gessen,\neuch von der Woll gekleidet, und was feist gewesen, habt ihr\ngemetzget! Itzt hungert sie nach Brot und dürstet nach Wein, aber\nnit nur nach Brot und Wein, sondern der Herr hat seinen Hunger und\nDurst gesandt, zu hören sein Wort, lauter, klar und rein und "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page6",
      "title": "lac/gary"
    }
  }), _vm._v(" trotz aller feisten\nBäuche und glatten Bälge, ohn alle menschliche Zusätz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Zum andern, nachdem der rechte Zehnte\nufgesetzt ist im Alten Testament und im Neuen alles erfüllt, nicht\ndesto minder wollen wir den rechten Kornzehnt gern haben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". Brav dahergered't,\nJunker Misträumer, fürtrefflich aufgereupzt, Gevatter\nKnollfink!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Den kleinen Zehnten wollen wir gar nit\ngeben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Oha! Euch\nhat der Teufel die Leviten gelesen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Hochwürdiger\nHerr, wollt Ihr mir eine Frage beantworten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Je nachdem,\nRitter!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Wohlan, stehet\ndem Bischof nach levitischem Gesetz der Zehnte von allem Land zu,\nwarum läßt er sich nit beschneiden? "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sensation\nbei einem Teil der Anwesenden, Gelächter bei einem\nandern.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Kotz,\nJunker, das mag Euch der Teufel beantworten!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Entsetzet ihr\neuch, liebe Herrn? Ei! leset doch die Leviten, und wann es darinnen\nnit gefodert wird, so will ich den Magister Hoogstraten zu Köln\nfortan nit mehr eine verabscheuungswürdige, verfluchte Bestie\nschelten!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Zum dritten ist der Brauch bisher gewest,\ndaß sie uns für ihre Eigenleut gehalten haben . . .«")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Bewegung, Lachen und Entrüstung unter der Mehrheit\nder Anwesenden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". Freilich wohl,\nEigenleut hat's geben, allsolange die Welt steht; da hadert mit\nunserm Herrgott, der hat es so eingericht't.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Itzt meinen\nsie, daß sie es Gott wollen abtrotzen, wann sie den Teufel zum Abt\nüber sich setzen, und daß er werde einen jeden Lüsbühel unter ihnen\nzum Herren machen.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Graf Wolf von Kastell kommt. Im übrigen füllt sich\nder Saal mehr und mehr mit Domherren, Rittern und allerhand\nHofbeamten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Was liest der\nSchreiber?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" ». . . der Brauch bisher gewesen, daß sie uns\n"), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page7",
      "title": "lac/gary"
    }
  }), _vm._v(" für ihre Eigenleut\ngehalten haben, welches zum Erbarmen ist, angesehen, daß uns\nChristus alle mit seinem kostbarlichen Blutvergießen erlöst und\nerkauft hat, den Hirten gleich allsowohl als den Höchsten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("nachsprechend.")]), _vm._v(" ». . . den Hirten gleich allsowohl\nals den Höchsten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Grumbach")]), _vm._v(". Dawider wäre\nwohl nichts nit zu sagen, ihr Herrn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Was leset\nIhr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(". Die gründlichen und\nrechten Hauptartikel aller Bauernschaft und Hintersassen der\ngeistlichen und weltlichen Oberkeiten, von welchen sie sich\nbeschwert vermeinen, auch die Handlung und Instruktion, so\nvorgenommen worden sein von allen Rotten und Haufen der Bauern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Die Zwölf\nArtikel, damit sie St. Velten beschissen hat. Wo habt Ihr sie\nher?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Ritter")]), _vm._v(". Ei, fliegen sie nit\nallenthalben in der Luft herum? Habt Ihr sie noch nit in Eurem\nHosensack gefunden?")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Eine große Anzahl unter Rittern und Domherren\nweist das Schriftchen vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Stimmen")]), _vm._v(". Da! Nehmt, lest!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(". Das Heftlein, daraus\nich euch vorlese, gestrenge Herrn, hätt ein Bote vom Götzen von\nBerlichingen unlängst über die Mauer hereingereicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Tuet seine\nPfauenfedern gewaltig herfür, der Götz!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Hat auch\nunserm allergnädigsten Bischof und Herrn absagen und des Stifts\nLehne aufkündigen lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(". »Datum zu Amorbach uf\nDonnerstag nach Misericordias Domini.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Ritter")]), _vm._v(". Habt ihr gehört,\nihr Herrn, wie greulich die Evangelischen zu Amorbach gehaust\nhaben? Ich war im Zwinger gegen den Glißberg, als die Türmer den\nBoten anbliesen. Bin auf die Mauer gestiegen und hab mit ihm\ngered't. Ist es der Köchle gewest und des Götzen von Berlichingen\nLeibknecht, den ich gut gekannt hab, von einem Gesellenritt her,\nden wir miteinander getan haben. »Köchle, was macht ihr«, hab ich\nihn angeschrien, »du und dein Herr? Seid ihr zu schwarzen Bauern\nworden?« – »Müssen wohl, fester Junker«, hat er mir Antwort geben,\n"), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page8",
      "title": "lac/gary"
    }
  }), _vm._v(" »es sei uns lieb\noder leid; aber es ist ein Jammer, wie sie alles verwüstet haben zu\nAmorbach, als die wütigen vollen Säu! Ich bin den Pfaffen mein\nLebtag gram gewest«, hat er geschrien, »aber hier ist christliche\nLieb auf türkische Art bewiesen.« – »Habt ihr euch bei den\nBenediktinern eingelegt?« schrei ich ihm zu. – »Ja, fester Junker,\nund es ist in der ganzen Abtei kein Nagel in einem Pfosten\nblieben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Kotz Leichnam!\nIhr Herrn, zu einem Scheißhausräumer wollt ich mich eh verdingen,\ndenn daß ich mich brauchen ließ wie der Götz und zu einem Obersten\nFeldhauptmann setzen, wo nichts dann heilloses Gesindel, Spieler,\nDiebsleut, Vaganten und Pfannenflicker hinter ihm drein fleugt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Ritter")]), _vm._v(". Es ist zweifelsohn,\nihr Herrn, und der Köchle hat es von Amorbach mitgebracht, Graf\nWilhelm von Henneberg hätt sich itzt auch mit den Bauern\nverbrüdert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Leider Gottes, es\nist, wie der Junker sagt. Mein Schwager hätt sich itzt auch mit dem\nGepövel vermenget. Haben ihm Dörfer, Schlösser und Abteien\nverwüstet, er ist von ihnen gedrungen und gezwungen worden.\nFreilich, wann sie mich schon am Schandpfahl hätten und den\nSchelmenschinder mit den glühenden Eisen an mich setzten, so wollt\nich mich doch lieber dem Teufel selbst verbrüdern als mit den\nrotzigen bäurischen Bluthunden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Das ist nun\nder herrliche und zuverlässige Trost, den Grave Wilhelm unserm\ngnädigen Herrn, dem Bischof Konrad, durch Schickung und Schrift so\nläßlich und sicherlich zugesagt hat, daß er sich itzt mit den\nBauern verbrüdert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". O der elenden\nHilf, wir hätten wohl lange genug verziehen sollen, eh uns\nversprochenermaßen von Henneberg war Kriegsvolk zukommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(". Die Brief sind Papier\nblieben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Domherr")]), _vm._v(". Sind in die Aschen\nfallen und sind verbrannt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Ich aber sag\neuch, ihr Herrn, der Grave Wilhelm von Henneberg verstehet die\nLäufte, wir aber verstehen die Läufte nit. Was hat denn der gemeine\nAdel all die Zeit von den geistlichen Herren zu befahren gehabt?!\nNot, Bedrückung Leibes und der Seele.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Und was hat\ner von den Bauern zu befahren gehabt? Wollt Ihr mir das wohl sagen,\nRitter? "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page9",
      "title": "lac/gary"
    }
  }), _vm._v(" Muß man es\nEuch erzählen, Herr, wie die Bauern unlängst zu Weinsberg mit dem\ngemeinen Adel gehandelt haben? Habt Ihr das wohl schon vergessen,\nRitter, daß sie wider Kriegsbrauch und Recht den Ludwig von\nHelfenstein durch die Spieße gejagt haben und vierzig gefangene\nRitter und Knechte dazu? Itzt ist es landkundig worden, wie sie\nallda gehauset. Haut und Haar eines Gemordeten hätt ein frommer\nevangelischer Bruder auf dem Spieße herumgetragen. Ein verrucht\nWeib und schwarze teuflische Hexe hätt dem Helfensteiner das\nBrotmesser in den Leib stoßen und mit dem Blut und Fett, das\nherausgeschweißet, ihre Schuhe geschmiert. Meinet Ihr dannoch,\nJunker, daß die Bäurischen ein freundlich Gemüt tragen wider Euch?\nBei Unsrer Lieben Frauen! glaubet mir, bleiben die Bäurischen oben\nliegen, so wird die Prophezei wahr, darin es heißt: der gemeine\nAdel soll einstmals müssen Elend aus Essig speisen, mit Mangel\nbeträufeln und in bitterer Wermut arme Ritter backen.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_c('span', {
    staticClass: "regie"
  }, [_vm._v("Viele Ritter schlagen an\ndie Wehre, und es erschallt mehrmals der Ruf:")]), _vm._v(" Rache für\nWeinsberg!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Itzt rufet ihr:\n»Rache für Weinsberg«, und Gott weiß es, daß ihr mit den\nWeinsberger Mordbuben nit wollet glimpflich verfahren, wann ihr an\nsie kämet. Wisset ihr aber auch, was die Bauern geschrien, als sie\nWeinsberg im Sturm genommen und Ritter, Bürger und Knechte zu\nPaaren trieben? »Rache für Wurzach! Rache für die siebentausend von\nWurzach!« Luget, ihr Herrn, der Truchseß hätt auch kein Erbarmen\nmit ihnen gehabt und den bösen Krieg allenthalben ausschreien\nlassen. Läßt auch die Profossen in sie arbeiten mit Galgen und Rad\nund der Bauern beste Leut abtun, als wenn es Hühner wären. Denkt an\nden frommen Prediger Jakob Wehe zu Leipheim.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Ei, wohl und\nbrav, so ist es recht; es sei mit Gewalt gered't und ihnen das Maul\ngestopfet, allen verfluchten, falschen, höllischen Propheten und\nSchwarmgeistern, wie sie der Satan allenthalben hat auferwecket.\nHeraus mit dem verfluchten, höllischen Unkraut, das er hat zwischen\nden Weizen gesäet, überall und allerwegen in deutschen Landen!\nImmer herausgerauft, gerissen, gestochen, gebrannt, immer\ndarniedergemäht, sei es lutherisch, karlstattisch, münzerisch,\nhussitisch oder wiclefitisch. Der Bock ist schon viel zu weit in\nGarten "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page10",
      "title": "lac/gary"
    }
  }), _vm._v(" kommen.\nImmer dareingewettert, Georg Truchseß! Sei ein echter, rechter\nSt. Georg und Drachentöter, so gefällt es Gott und unserer\ngebenedeiten Jungfrau Maria. War es eh geschehen, die Ufruhr sollt\nschwerlich also überwälzig worden sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Zum vierten ist bisher bräuchlich gewest,\ndaß kein armer Mann Gewalt gehabt hat, das Wildpret, Vögel oder\nFische im fließenden Wasser zu fahen. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Gelächter\nin der Mehrzahl.")]), _vm._v(" Welches uns ganz unziemlich und\nunbrüderlich dünkt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Daß euch die\nDrüs, mit meinem Willen soll kein Rülze von einem Bauern in meinem\nGejaide eine Armbrust aufbringen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Zum fünften sind wir auch beschweret der\nBeholzung halben, dann unsre Herrschaft haben ihnen die Hölzer alle\nallein geeignet. Zum sechsten ist unsre hart Beschwerung der\nFrondienst halben, welche von Tag zu Tag gemehret werden und\ntäglich zunehmen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". Die Sach is itzt\nso bestellt: Der Bauer will alleweil auf der faulen Haut liegen, in\nder Trinkstuben sich auftun, über der Geschrift disputieren und den\nPrädikanten nachlaufen. Aber der Pflug ist ihm zu schwer worden.\nWird er itzt aber bei Eiden und Pflichten gemahnt, oha, so ist er\nder Junker Dörflinger und rühret sich so wenig, als hätt ihn der\nSatan aus einem Leimklotz gemacht. Wendet die Herrschaft itzt aber\nden Ernst vor und läßt einen aufsässigen Lauskopf und\nwiderspenstigen Esel in die Eisen tun – kotz Schweiß, so ist man\nder allergottloseste Tyrann und Wüterich!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liest.")]), _vm._v(" »Zum achten sein wir beschwert und\ndiejenigen, die Güter innehaben, daß dieselben Güter die Gült nit\nertragen können.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Das nimmt mich\nnit wunder, wahrlich nit. Gebären sie sich nit schlimmer auf ihren\nGütern mit Schlemmen, Dämmen und Verprassen als der lüderlichste\nHauser von Edelmann? Da ist nichts dann Hochzeiten, Fressen,\nWeinsaufen und Wiedervonsichspeien. Statt groben Zwillichs, wie es\neinem groben Flegel gebühret, tragen sie Tuch aus Mecheln und\nLondon. Ihre Weiber wollen es den Edelfrauen zuvortun an\nKleiderpracht, und manch eine hat einen Meierhof wert in einer\nKetten um den Hals. Ihre Töchter behenken sie mit Seide und Sammet,\nMarder, "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page11",
      "title": "DaoH/gary"
    }
  }), _vm._v("\nHermelin und Goldstoff, daß ein Edelfräulein dawidergehalten einer\nStallmagd gleichsiehet.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Lorenz von Hutten kommt erschöpft und atemlos.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". Neue Zeitung,\nihr Herrn!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". Ist dir der Teufel\nbegegnet, Lorenz?!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". Gelobt sei Gott\nund die heilige Anna, daß ich im Trocknen bin! Hat mir einer den\nGaul unterm Leib weggebirst, als wir beide, mein Gaul und ich,\ndurch die Furt wollten und mitten im Main schwammen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Sie schießen mit\nden Handrohren?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". Ei, freilich,\nwißt Ihr das nit? Die Würzburger Häcker, in den Weinbergen am Main,\nhaben die Handrohre mit ihnen genommen und bei der Arbeit neben\nsich liegen. Wenn sie eines bischöflichen Reuters etwa von ungefähr\nansichtig werden, ei nun, so machen sie Jagd auf uns, als ob wir\nAntvögel wären, piff, paff, hinter dem Mäuerlein hervor. Hab ein\ngut Roß, das mit dem Blei im Leib noch einen tapfren Sprung\nvorwärts getan, daß ich, Gott sei gelobt, wie die Katz auf die Füße\nzu stehen kam und nit, geharnischt wie ich war, im tiefen Wasser\nelendiglich ersoff.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Ist denn kein\nHenker meh unten zu Würzburg, der einen verdammten meuchlerischen\nMörder und Friedbrecher voneinander kann schlagen, daß der Kopf das\nkleinere und der Leib das größere Teil ist?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". Ei nein. Dann\ndie Würzburger haben den Meister Jakob davongejagt, weil er gesagt\nhat, es wird mit der Ufruhr zu Würzburg kein End nit nehmen, bevor\ner nit etlichen, dem Georg Bermetter voran, die Grint abgehauen.\nDafür wollten ihn die Würzburger tot haben; so ist er itzt hie auf\nder Burg mitsamt seinen Knechten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(". Heut ist zu Würzburg\nkein Zeuge, Herr Graf, der etwas ablegen, kein Notario, der etwas\nschreiben, kein Advokato, der den Prozeß formieren, kein\nStadtdiener, der angreifen, kein Richter, der examinieren, keine\nObrigkeit, die urteilen, gleichwie kein Scharfrichter ist, der\nexequieren kann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Was ist's\nfür Zeitung, die Ihr bringt, fester Junker?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". Was ich für\nZeitung bringe, liebe Herrn? Nit mehr noch minder, als daß ich gute\nKundschaft hab und glaublich bericht't bin, daß alle Haufen der\nBauern uf Würzburg zu ziehn und daß, solange die Welt steht, "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page12",
      "title": "sf-bo/gary"
    }
  }), _vm._v(" kein solches Reisen,\nWebern und Inhaufenziehen gewesen ist mit Panieren, Schweinspießen,\nFlegeln, Hellebarden, Handrohren, Wägen und Hakenbüchsen. Ich bin\nglaublich bericht't, daß die Evangelischen von Amorbach her\nunterwegs sind, daß sie ein Kruzifix mit sich tragen und geschworen\nhaben, wie sie das Kind im Mutterleibe wollten verderben, wenn\nihnen der Bischof, unser allergnädigster Herr, das Schloß nit wollt\ngutwillig eingeben. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Bewegung und Erregung unter\nden Rittern.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Wer vor Dräuen\nstirbt, dem läutet man mit Eselsfürzen aus, ihr Herrn. Habt Ihr\nnoch meh solcher Botschaften, Ritter?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". Ja, Kitzingen\nist in der Brüderschaft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Ritter")]), _vm._v(". Potz Blau, Kitzingen\nhat sich mit den Bauern verbrüdert?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". Auf\nEdelmannswort!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(". Wird den\nMarkgrafen Kasimir zu Ansbach übel verdrießen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Meinet Ihr? Mir\nwill viel eh scheinen, daß den ganzen bäurischen Handel zu Ansbach\nkein übel Aug ansiehet. – Ist nicht der Markgraf den lutherischen\nMaterien zugetan, so gut wie der Henneberger? Ist es nit\nlandkundig, daß der Schwarzenberger, der gewaltige Ritter und\nLutheraner, zwischen Ansbach und den bäurischen Lägern Botschaft\nhin und wider reitet? Es dünket mich nit unmöglich, daß\nmarkgräfisches Geschütz mit den bäurischen Flegeln zu gleicher Zeit\nhie oben anklopfet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Meinest du uns\nscheißbange zu machen, Wulf, mit überhirnischem Zeug und\nSpinnstubenmärlein? Mag es den Markgrafen gelüsten als einen Fuchs\nnach der feisten Gans und wär auch all sein Gemüt darauf gericht't,\ndes Stifts Güter zu erschnappen und als ein Herzog in Franken\nEinzug zu halten auf Unserer Frauen Berg, so weiß er doch, daß es\nmit dem Bundschuh just so wenig möglich sein kann, als daß man über\ndem Rheinsturz bei Schaffhausen auf einen Turm steiget.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Sebastian von Rotenhahn, Hofmeister des Bischofs,\nin Rüstung, tritt ein und durchschreitet den Raum, im Begriff sich\nzum Bischof zu begeben. Man hält ihn an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _vm._v(". Saget, Euer\nHochgelahrt, bestätigt sich das Gerücht? Hat sich Kitzingen dem\nFlorian Geyer und seinen Schwarzen zugelobt? "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page13",
      "title": "Corny/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Liebe,\ngetreue Freunde und Herrn! Habet Geduld, verziehet ein wenig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Ritter.")]), _vm._v(" Weshalb hat man uns\nberufen, Euer Edel?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Das sollt\nihr von Seiner Liebden, unserm gnädigsten Fürsten und Herrn, in\nhöchsteigener Person erfahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Ritter.")]), _vm._v(" Es heißt: von allen\nSeiten zögen die Gewalthaufen der Bauern wider uns, hätten\ngeschworen, nichts Edles leben zu lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Liebe\nGetreue, habet Geduld, verziehet ein wenig!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Ritter.")]), _vm._v(" Wird der Bischof\ndas Schloß zutun, oder wird er es räumen lassen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Ihr Herrn,\nzu Weinsberg hatte der Florian Geyer leichtes Spiel, hie aber sind\nfestere Mauern, ein unüberwindliches Schloß, sofern wir einig sind.\nEs wäre doch gar jämmerlich und schändlich, wenn wir einem so edlen\nHerrn, milden, gütigen und gerechten Fürsten, wie es unser Bischof\nKonrad ist, nit sollten beiständig sein. Würde auch einer\nhochberühmten fränkischen Reichsritterschaft zu unauslöschlicher\nSchmach und Schande gereichen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Wohlan, Bastian,\nder Bischof ist ein frommer und gerechter Herr, und ich hab nichts\nwider ihn; aber der ganze Handel hat in keinem Weg mit der Person\nzu tun. Ist einstmals ein Ritter gewest, und war nie keiner ihm\ngleich, stolz wie er, mutig wie er, treu und fest an die Wahrheit\ngehängt. Der hat wider die Pfaffen geschrieben, solang ihm ein\nÄderlein hielt: Ulrich von Hutten hat er geheißen. Ei nun, der\nHutten ist tot und hin; die Pfaffen haben ihn in Armut, Elend und\nTod gehetzt. Aber sein Werk ist blieben, seine Saat ist blieben und\nstehet in Blüte. »Wach auf«, hat er geschrieben, »du edle deutsche\nFreiheit«, und die edle deutsche Freiheit ist aufgewacht. Aber\nitzt, Bastian, da Gott in die Sachen geschaut und sie auferwecket\nhat, itzt schlafet Ihr. Dazumalen waret ihr ein Herz, du und der\nHutten. Aber alsbald er dahin ist, bist du mit ihm gestorben. Oder\nwillst du mir sagen, daß du noch lebst? Potz, wie hättest du deinen\nBlutsbruder ungerächt können lassen! Wie hättest du dich mögen von\nden Pfaffen brauchen und andern zu einem Wall auftürmen lassen\nwider die . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Was redest\ndu dich in Hitze, "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page14",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" Wolf! Wider wen redest du, wider was redest\ndu? Soll eine allgemeine, große Reformation sich anfahen, wohlan,\nsetze ich mich dawider, setzt sich der Bischof dawider? Hat er sich\nnicht vielmehr hoch erboten, wo gerechte Beschwerden seien,\ndieselben zu hören, unbillige Bürden zu ringern und abzutun, allem\nFolge zu tun und Statt zu lassen, was andere Fürsten, Herren und\nHintersassen beschließen und ufrichten würden? Siehest du nit, daß\nes hie allein heißt, sich wider Tollheit und Raserei setzen, die\nalles darniedertritt, zerstampfet und verwüstet, sauren Schweiß des\nArmen, Häuser der Reichen, Schlösser, Kirchen, Schätze der Kunst\nund Gelehrsamkeit? Ei, Wolf, in welche Verblendung bist du geraten!\nLebte der Ulrich von Hutten, hie sollt er neben mir stehen, so wahr\nich sein Freund bin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _vm._v(". So wahr Gott\nlebet, hie stünd er neben uns.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Ja, Wolf,\nso ist es, und siehe doch um dich! Hat nicht der Luther sich wider\ndie Bauern gewandt und wider ihre blutgierigen, höllischen Haufen\nund Rotten geschrieben?")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Der Bischof Konrad von Würzburg mit großem\nGefolge.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell,")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("den Bischof zuerst gewahrend.")]), _vm._v(" Unser allergnädigster\nHerr, der Bischof Konrad zu Würzburg und Herzog von Franken, vivat\nhoch!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Die Mehrzahl der Ritter.")]), _vm._v(" Hoch!\nHoch!")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Der Bischof begibt sich nach dem Thronsessel; das\nGefolge, darunter der junge Oberste Hauptmann, Dompropst Friedrich\nvon Brandenburg, gruppiert sich um ihn. Nachdem Stille eingetreten,\nredet der Bischof stehend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bischof Konrad.")]), _vm._v(" Liebe Freunde, ich\nweiß, daß ihr es alle treulich und gut mit mir meinet als meine\nDiener, Vasallen und Stiftsverwandte. So hab ich euch dann berufen\nlassen, um euch kundzutun, wie ich mich in diesen geschwinden und\nje länger je mehr bedrohlichen Läuften fürder zu halten gesonnen\nbin.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Es ist euch bekannt, wie dieserzeit\nallenthalben in deutscher Nation sich eine Aufruhr erhebt hat und\nder gemeine Mann sich bedrückt vermeinet mit unbilligen und\nunträglichen Lasten.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Als sich im März die Bauern in der Rothenburger\nLandwehr zu Ohrenbach und Bretheim erhoben und rottieret, hab ich\ndem Statthalter zu Mainz, auch dem Pfalzgrafen "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page15",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" Ludwig um Hilf zugeschrieben.\nAls danach Markgraf Kasimir einen Tag gen Neuenstadt\nausgeschrieben, wie man sich ufs fürderlichste und fruchtbarlichste\nwider das Vornehmen der Bauern in Rüstung schickte, zu beraten, hab\nich meine Räte dorthin verordnet. Aber es ist nichts\nFruchtbarliches und Fürderliches auf dem Tag gehandelt worden. Nu\nhab ich meine Ritterschaft und Landschaft beschrieben und in des\nStifts Amten ufbieten lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Haben auch meine Bauern allsogleich zu den\nWehren griffen, Reispanier ufgesteckt, Schläge und Fuhrten\nvermacht, aber, als itzt am Tag ist, allein mir zuleid, nit mir\nzulieb. Nachdem der Bauern unchristlich und unbrüderlich Fürnehmen\nim hohen und niedern Deutschland immer bedrohlicher anwuchs und der\nFlorian Geyer Weinsberg im Sturm genommen, hab ich zum andern Malen\nSeiner Liebden, dem Markgrafen zu Ansbach, meinem lieben Freund und\nHerrn, Werbung um Hilfe tun lassen und hab ihme durch Seiner\nLiebden leiblichen Bruder, unsern lieben getreuen Freund und\nDompropst "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("– dabei legt er die Hand auf Markgraf\nFriedrichs Schulter –")]), _vm._v(" Markgrave Friedrich in Person\nangesucht. Ist mir aber keine tröstliche Antwort gefallen, da\nSeiner Liebden nit minder bedroht ist und die gleiche Ufruhr,\nEmpörung und Not zu gewärtigen hat dann wir. Derweilen ist die\nSintfluß immer mehr gestiegen, hat alles überwälzet, Herrschaften,\nFürstentümer, Klöster, Burgen und Städte; hab ich mich um\nBundshülfe umgetan bei dem Bund zu Schwaben, hab meine Räte in der\nBauern Läger geschickt, hat aber alles nit mögen fruchten.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Liebe Freunde und Herrn, es kann euch das alles\nnit unbekannt sein, ingleichen, wie ich mich hoch und willig\nerboten, zur Abwendung und Milderung gerechter Beschwerden meiner\nbischöflichen Stadt und Landschaft. Gott weiß es, daß ich alles in\nGüte zu tun bereitwillig war, damit die Sachen zu dieser Weiterung\nnit erwachsen möchte, war aber alle Geschicklichkeit und Vernunft\ngar umsonst, kein gütlich Wort nit gehöret, alles in Luft geblasen.\nSo ist es zu Würzburg dahin kommen, daß sie die Haufen der Bauern\nmit Schriften zu sich geladen; Bürgerschaft und Rat sind eines\nSinns, möchten je eher je lieber zu den Bauern fallen und helfen,\nunser festes Schloß ab dem Berg werfen. Nachdem ich dies alles nu\nhab sehen müssen und erkannt hab, daß auch von Grave Wilhelm von\nHenneberg Hilfe nit meh "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page16",
      "title": "r_a_5/gary"
    }
  }), _vm._v(" zu gewärtigen ist, auch nichts Gewissers ist,\ndann daß die Bauern vor Unserer Frauen Berg ziehen, den belägern\nund zu nötigen unterstehen werden, hab ich mit meinen Räten\nGespräch halten und für gut befunden, mich auf und hinweg zu tun.\nJa, lieben Freunde, so stehe ich itzt vor euch. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Mit starker innerer Bewegung.")]), _vm._v(" Von all meinem\nFürstentum und Landen ist mir nichts überblieben als dies einige\nSchloß, und davon muß ich itzt auch ziehen. Gott aber mag wissen,\nob ich je wieder dareinkomme.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Pause der Ergriffenheit, stumme Bewegung und\nFlüstern unter den Rittern.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Es ist mir nit wenig beschwerlich,\nhinwegzuziehn und so viele Fürsten, Grafen, Ritter und Knecht in\nder Burg «zu verlassen. Aber es ist von mir und meinen Räten für\ngut angesehen, daß ich mich hinweg und zu Pfalzgrave Ludwigen,\nKurfürsten, tue, um persönlich Hülf zu erlangen oder des\nSchwäbischen Bundes zu Ulm Hülfe. Seid gewiß, daß ich keine Müh\nsparen, auf nichts andres denken will bei Tag und Nacht, dann wie\nich euch erlöse aus Fahr und Ängsten, darin ich euch zurücklaß.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Gemurmel und Geflüster unter den Rittern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("tritt vor")]), _vm._v(". Hochwürdiger Fürst und Herr!\nEuer fürstlichen Gnaden Willen und Meinung haben wir vernommen und\nbitten Euer fürstliche Gnaden, nit anders von uns zu denken, als\ndaß sich ein jeder von uns zu halten gedenkt, wie ihm nach adligen\nEhren gebührt und zusteht. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Entschiedene\nZustimmungsbezeugung bei der Mehrzahl")]), _vm._v(". Es ist keiner unter\nuns Franken, der nit gewillt ist, Leib und Gut bei seinem Herzog\nund Herrn zu lassen . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("leise")]), _vm._v(". Der Teufel hat ihn zu einem Herzog in Franken\ngemacht!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(",\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("fortfahrend")]), _vm._v(" . . . und sich zu\ngebrauchen, weil er ein'n Arm zu regen die Kraft hat.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Meine guten Freunde, Gesellen und Brüder von\nden fränkischen Adelsbänken wissen allzuwohl, was itzt auf dem\nSpiel steht.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Der Pöbel hat sich erhebt allenthalben, und wo\netwas hoch ist, da recket er seine Arme nach, da greifen sie mit\nihren unreinen Händen. Nennen sich evangelische Brüder und ihre\nEinung eine christliche Brüderschaft, unserm Herrn und Seligmacher\nJesu Christo zu einem Greuel und Schmach. Hießen viel baß höllische\nBrüder und ihre Einung "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page17",
      "title": "r_a_5/gary"
    }
  }), _vm._v(" eine türkische Brüderschaft, da sie überall wüten\nmit Weingärten zerreißen, Früchte zertreten, mit Mord, Brand,\nWeiber schänden, Kisten fegen und Säckel leeren.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Es ist leider am Tag, daß Fürsten, Herrn und\nGewaltigen, kurzum der Oberheit allenthalben das Schwert und das\nHerz entsunken ist. Ein großer Schrecken ist in sie gefahren und\nhat sie gelähmet. Keiner reichet dem andern die Hand und rühret\nsich nit, bis ihm die Mauer, daran er sich lehnet, selbst zu heiß\nwird.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Gnädigster Herr, durchlauchtigster Fürst! Uns\nalle hier lähmet der Schrecken nit. Wahr ist's: das Gesindel fleugt\nund schneit zu, allweg, als die Fliegen im Sommer. Es ist schier,\nals habe es in deutschen Landen allenthalben Bauern geregnet und\ngehagelt, aber es ist der mehre Teil ein nackt, ungeniet Volk, die\nden Hasen im Busen haben, Weinbuben und Tabernierer, die\nzuallererst nach den Fässern und Würsten laufen und nit gewohnt\nsind, einen Mann zu finden.")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Liebe, fromme Gesellen! In unsrer Besatzung ist\nkeiner, der nit ein Mannskerl, von unserm Obersten Hauptmann,\nMarkgrafen Friedrich von Brandenburg, bis herab zum allergeringsten\nBuben. Laßt sie nur kommen und ihnen die harten bäurischen\nGrützköpf an unsern Mauern zerstoßen. Wir wollen sie mit\nStückkugeln laus'n, daß ihnen soll angst und bange werden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rufe der Ritter")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("kriegerisch begeistert")]), _vm._v(". Her! her!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Wir wollen\nihnen die Würzburger Osterfladen mit Pulver bestreuen und mit Pech\nund Schwefel begießen. Sie sollen bleierne Birnen dabei zu\nschlucken bekommen, soviel sie nur immer mögen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geschrei der Ritter")]), _vm._v(". Her! her!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(". Unsere\nMauern sind fest, die Gräben tief; Zwergzäune sind ufgericht't, ein\nLichtzaun ist gemacht, Zwinger, Tor, Turm sind in gutem Stand. Wir\nhaben Pulver und Proviant, Wasser, Wein, Holz, Kohle, Mehl, Speck.\nWir können in Hülle und Fülle leben und uns ihrer erwehren zween\nMonat und länger hinaus. Wir wissen wohl, es ist nit allein um das\nSchloß getan, es ist um die ganze deutsche Nation getan. Dies ist\nder Fels, Freunde; unterspület ihn die Flut, so stürzet alles nach\nund versinket, und bleibet nichts über von ganzer großer deutscher\nNation dann ein Haufe elender Steine und Trümmer. "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page18",
      "title": "r_a_5/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_vm._v("Gnädigster Herr und Fürst! Gott hat uns auf\ndiesen Felsen gestellt, und wir wollen mit Gott ausharren, ihn\nhüten und verteidigen, und wär es wider den Teufel selbst, weil wir\nnoch einen Blutstropfen im Leib und einen Hauch in der Brust\nhaben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bischof Konrad")]), _vm._v(". Das walte Gott und\nder Ritter St. Georg!")]), _vm._v(" "), _c('p', {
    staticClass: "leftmarg"
  }, [_c('span', {
    staticClass: "regie"
  }, [_vm._v("Ein Tumult und\nBegeisterungstaumel bricht jetzt los. Die Ritter schreien")]), _vm._v("\nHer! Her!, "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("umarmen sich, schütteln sich die\nHände unter Tränen.")]), _vm._v(" Vivat, Bischof Konrad! Vivat unser\nBischof und Herr! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("und wiederum")]), _vm._v(" Her! Her!\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schallt es durcheinander.")])]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Inmitten der allgemeinen Bewegung entfernt sich\nder Bischof und sein Gefolge. Dompropst Markgraf Friedrich von\nBrandenburg bleibt mit kleinem Gefolge zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunz von der Mühlen")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schreit")]), _vm._v(". Ich will den Florian Geyer in ein Mauseloch\nprügeln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Ritter")]), _vm._v(". Bauer, hüt dich,\nmein Roß schlägt dich!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunz von der Mühlen")]), _vm._v(". Wohl her! wir\nwollen den Florian Geyer und seine Weinsberger Mordbuben in ein\nMauseloch prügeln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Geyer")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu Wolf von Hanstein")]), _vm._v(". Wolf, Wolf, ich halt mich nit\nlänger. Soll der Bärenhäuter meinen leiblichen Bruder also\nbeschimpfen dürfen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("laut zu Kunz von der Mühlen")]), _vm._v(". Der Florian Geyer ist\nein so ehrlicher Ritter und Reuter von Adel als irgendeiner im\nLande zu Franken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunz von der Mühlen")]), _vm._v(". Der Florian\nGeyer ist ein halssträflicher Schuft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu Sebastian Geyer, der losfahren will")]), _vm._v(". Leid dich,\nSebastian; laß das gespornte Hähnlein krähen auf seinem Mist. Wann\nwollt Ihr doch Euren Adelsbrief bezahlen, he, Junker\nStraßenfeger?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunz von der Mühlen")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schreit")]), _vm._v(". Der Florian Geyer ist ein Ächter, ein Feind\ndes Kaisers und ganzer deutscher Nation. Hat zu Pavia dem Franzosen\ngedient.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(", "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("dicht an Kunz von der Mühlen")]), _vm._v(". Männlein, ob dir der\nHenker unter deinen gepichten Haaren noch Ohren gelassen hat, das\nweiß ich nit. Aber du bist ein gehelmter Esel, wann du sie nit\nhast. Und wenn du nit aufhörst zu schreien, will ich dir die\nHarnischhand in dein Lästermaul stopfen, daß der rote Schweiß\nhernachgehet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von")]), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Geyer")]), _vm._v(". Wolf, tritt beiseit. Die Gecksnase ist\n"), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page19",
      "title": "Teledahner/gary"
    }
  }), _vm._v(" von den\nBauern entloffen. Denket sich hie groß aufzutun am Hof, leicht ein\nLehen zu erschnappen, mit Gramanzen und Maulmachen. Der Teufel\ngeseg'n es ihm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Friede, ihr\nHerrn. Unser Oberster Hauptmann, der Markgraf Dompropst, begehrt zu\nreden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Sebastian –!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Geyer")]), _vm._v(". Daß dich potz\nMarter schänd! der Hund soll mir büßen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Komm mit\nmir!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Geyer")]), _vm._v(". Wohin?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Der Pfaff führt\neuch am Seil. Ich geh zu den Bauern. Gehst du mit?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Geyer")]), _vm._v(". Es geht nit\nan, Wolf, streitet mir wider Pflicht und Gewissen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Markgraf Friedrich")]), _vm._v(". Lieben Freunde,\nvon unserm gnädigsten Herrn zum Obersten Hauptmann über dies Schloß\ngesetzt, tu ich euch kund und zu wissen, daß ich von Stund an die\nBurg zutun will und zur Verteidigung beschicken. Drum welcher Lust\nhat, in der Besatzung zu bleiben, der begebe sich auf den\nSchloßhof. Allda wird der Eid verlesen werden, danach sich zu\nhalten jeder geloben und schwören soll. Wer aber nit Lust hat, uns\nfürder beiständig zu sein, der trete itzt ab.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Wolf von Hanstein tritt, während alles still ist,\naus der Reihe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _vm._v(". Wo willst du hin,\nWolf?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Dem Evangelium\neinen Beistand tun.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Die Ritter")]), _vm._v(". Schuft, Schurk,\nVerräter, Memme!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("schreit rasend zurück.")]), _vm._v(" Fresse die Pest alle\nPfaffenknechte! Es lebe die deutsche evangelische Freiheit!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Die Ritter")]), _vm._v(". Hoch unser Bischof und\nHerr, hoch Bischof Konrad von Würzburg!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _vm._v(". Bundschuh!\nBundschuh! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ab.")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page20",
      "title": "MEsswein/gary"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0